import styled from 'styled-components'

import { ButtonPlain, withFocusVisible } from '@subaio/components'

import { toRem } from 'styles'

import { focusVisibleOutline } from 'components/FocusVisible'

type Props = {
	isFocusVisible: boolean
}

export const ButtonIcon = withFocusVisible(styled(ButtonPlain)<Props>`
	display: flex;
	align-items: center;
	justify-content: center;

	width: ${toRem(36)};
	height: ${toRem(36)};

	${focusVisibleOutline}
`)
